document.addEventListener('DOMContentLoaded', () => {

	if (window.innerWidth >= 1025) {
		// index page slider
		const swiper = new Swiper(".about-slider", {
			slidesPerView: 5,
			spaceBetween: 30,
			freeMode: true,
			slideToClickedSlide: true,
			simulateTouch: false,
			touchStartPreventDefault: false,
			// centeredSlides: true,
			mousewheel: {
				enabled: true,
				sensitivity: 1,
			},
		});

	} else {
		$('.about-slider').removeClass('swiper');
		$('.about-slider .swiper-wrapper').removeClass('swiper-wrapper');
		$('.about-slider .swiper-slide').removeClass('swiper-slide');
	}

});